import { combineReducers } from "redux";
import { apiReducer } from '../../utils/api/reducer';
import { StackConstraint } from "./types";
import { Constants } from "./constants";
import { SlateResponse } from "../../common/store/types";

export const poolSize = (state = 250 as Number, action: any) => {
  switch (action.type) {
    case Constants.SET_POOL_SIZE:
      return action.payload;
    default:
      return state;
  }
}

export const percentToFirst = (state = 25 as Number, action: any) => {
  switch (action.type) {
    case Constants.SET_PERCENT_TO_FIRST:
      return action.payload;
    default:
      return state;
  }
}

export const liveContestId = (state = '' as string, action: any) => {
  switch (action.type) {
    case Constants.SET_LIVE_CONTEST_ID:
      return action.payload;
    default:
      return state;
  }
}

export const generatedSlate = (state = {} as SlateResponse, action: any) => {
  switch (action.type) {
    case Constants.SET_GENERATED_SLATE:
      return action.payload;
    default:
      return state;
  }
}

export const loading = (state = false, action: any) => {
  switch (action.type) {
    case Constants.SET_LOADING:
      return action.payload;
    default:
      return state;
  }
}

export const exportableLineups = (state = '', action: any) => {
  switch (action.type) {
    case Constants.SET_EXPORTABLE_LINEUPS:
      return action.payload;
    default:
      return state;
  }
}

export const boostedPlayers = (state = {}, action: { type: string, payload: { player: string, boostValue: number}}) => {
  switch (action.type) {
    case Constants.SET_BOOST_PLAYER:
      state[action.payload.player] = action.payload.boostValue;
      return {...state};
    case Constants.REMOVE_BOOST_PLAYER:
      delete state[action.payload.player];
      return {...state};
    case Constants.CLEAR_BOOST_PLAYERS:
      Object.keys(state).forEach(x => delete state[x]);
      return state;
    default:
      return state;
  }
}

const initialConstraintState: StackConstraint[] = [
  {
    primary: 1,
    secondary: 0,
    percent: .45,
  },
  {
    primary: 2,
    secondary: 0,
    percent: .25,
  },
  {
    primary: 3,
    secondary: 0,
    percent: .05,
  },
]

export const stackConstraints = (state = initialConstraintState, action: any) => {
  switch (action.type) {
    case Constants.SET_CONSTRAINTS:
      return action.payload;
    default:
      return state;
  }
}

export const runback = (state = {primary: 0, secondary: 0, percent: .25}, action: any) => {
  switch (action.type) {
    case Constants.SET_RUNBACK:
      return action.payload;
    default:
      return state;
  }
}

export const diversity = (state = 0, action: any) => {
  switch(action.type) {
    case Constants.SET_DIVERSITY:
      return action.payload;
    default:
      return state; 
  }
}

export const lineupDiversity = (state = 0, action: any) => {
  switch(action.type) {
    case Constants.SET_LINEUP_DIVERSITY:
      return action.payload;
    default:
      return state; 
  }
}

export const useCustomExposures = (state = false, action: any) => {
  switch(action.type) {
    case Constants.USE_CUSTOM_EXPOSURES:
      return action.payload;
    default:
      return state;
  }
}

export const lateSwapReducer = combineReducers({
  generatedSlate,
  loading,
  boostedPlayers,
  stackConstraints,
  runback,
  diversity,
  percentToFirst,
  liveContestId,
  lineupDiversity,
  contestPlayers: apiReducer(Constants.SET_CONTEST_PLAYERS),
  contestLineups: apiReducer(Constants.SET_CONTEST_LINEUPS),
  contestGenLineups: apiReducer(Constants.SET_CONTEST_GEN_LINEUPS),
  contestStacks: apiReducer(Constants.SET_CONTEST_STACKS),
  exportableLineups,
  poolSize,
  useCustomExposures,
})